import * as React from 'react'
import classNames from 'classnames'
import './loader.scss'

interface IProps {
  className?: string
  size?: 'button' | 'small' | 'large'
  color?: 'grey' | 'white'
  position?: 'left' | 'right'
}

export const Loader = ({ className, size, color, position }: IProps): JSX.Element => {
  const classes: string = classNames(
    'loader',
    className,
    {
      [`loader--${size}`]: !!size,
      [`loader--${color}`]: !!color,
      [`loader--${position}`]: !!position
    }
  )

  return (
    <div className={classes} aria-hidden="true" />
  )
}
